import { Permiso_urb } from './../../../models/permiso_urb.model';
import { Component } from "@angular/core";
import { FormGroup, FormControl, Validators } from '@angular/forms';


@Component({
    selector: "page-permiso_urb",
    templateUrl: "./permiso_urb.component.html"
    
})


export class Permiso_urbComponent {
    public rows = [];
    public actualRow;
    public permiso_urb: Permiso_urb;
    public form;
    
    constructor(){
        this.form = new FormGroup({
            permiso_urb1: new FormControl('', Validators.required),
            permiso_urb2:new FormControl('', Validators.required)
            
        })
        if(!JSON.parse(localStorage.getItem("permiso_urb"))){
            localStorage.setItem("permiso_urb", JSON.stringify(this.rows));
        }else{
            this.rows = JSON.parse(localStorage.getItem("permiso_urb"));
            this.form.controls['permiso_urb1'].setValue(this.rows[0]?this.rows[0].Vialidad:'NO')
            this.form.controls['permiso_urb2'].setValue(this.rows[0]?this.rows[0].Otros:'NO')
        }
        this.permiso_urb= {Vialidad:'',Otros:''}


    }

    add_permiso_urb(){
        localStorage.setItem("permiso_urb",JSON.stringify([]));
        this.actualRow = localStorage.getItem("permiso_urb");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            Vialidad: this.form.value.permiso_urb1, 
            Otros: this.form.value.permiso_urb2
        })
        localStorage.setItem("permiso_urb", JSON.stringify(this.rows));
        console.log(JSON.parse(localStorage.getItem("permiso_urb")));
    }
  
    delete_permiso_urb(id){
        for(let x = 0; x < this.rows.length; x++){
            if(id == x){
                this.rows.splice(x, 1);
                localStorage.setItem("permiso_urb", JSON.stringify(this.rows));
            }
        }
    }   
}